export function padToThreeDigits(num) {
  const parsedNum = parseInt(num, 10); // Always good to specify radix
  return parsedNum.toString().padStart(3, '0');
}


export function padToFourDigits(num) {
  const parsedNum = parseInt(num, 10); // Ensures it's an integer
  return parsedNum.toString().padStart(4, '0');
}